import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="app-footer">
      Developed by{" "}
      <a
        href="https://github.com/joaoacastro"
        target="_blank"
        rel="noopener noreferrer"
      >
        joaoacastro
      </a>
    </footer>
  );
};

export default Footer;
